import * as React from "react";
import { Input, InputGroup, InputGroupText, Label } from "reactstrap";
import "./SearchBox.css";

interface ISearchBoxProps {
  placeHolder: string;
  label?: string;
  icon?: React.ReactElement;
  value?: string | number;
  onChange?: (e: any) => void;
  numberOnly?: boolean;
  maxLength?: number;
  error?: boolean;
  errorMessage?: string;
  disabled?: boolean;
  required?: boolean;
}

const SearchBox: React.FunctionComponent<ISearchBoxProps> = (props) => {
  return (
    <div className="mb-2">
      {props.label && (
        <Label className="mb-1 text-start search-label text-muted">
          {props.label}
          {props.required && (
            <span className="mx-1" style={{ color: "red" }}>
              *
            </span>
          )}
        </Label>
      )}
      <InputGroup
        className={`input-group-parent ${
          props.disabled ? "disabled-addon" : ""
        }`}
      >
        <Input
          type={props.numberOnly ? "number" : "text"}
          value={props.value}
          onChange={props.onChange}
          placeholder={props.placeHolder}
          className="border-end-0 input-control form-control-search-box"
          maxLength={props.maxLength}
          disabled={props.disabled}
        />
        <InputGroupText>{props.icon}</InputGroupText>
      </InputGroup>

      {props.errorMessage && (
        <div className="search-helper-text mt-2">{props.errorMessage}</div>
      )}
    </div>
  );
};

export default SearchBox;
